function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  className: "st0",
  d: "M37.4,68.4L16.4,78.5c-1.1,0.5-2.4-0.3-2.4-1.5V36.2c0-1.2,1.3-2,2.4-1.5l20.9,10.6c0.6,0.3,0.9,0.8,0.9,1.5 v20.1C38.3,67.5,37.9,68.1,37.4,68.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M80.8,94.2h-8.1c-0.3,0-0.6,0.1-0.7,0.4l-21.6,33.6c-0.4,0.6,0,1.3,0.7,1.3h8.1c0.3,0,0.6-0.1,0.7-0.4 l21.6-33.6C81.9,95,81.5,94.2,80.8,94.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M98.4,94.2h7.7c0.3,0,0.7,0.2,0.8,0.5l21.4,33.3c0.4,0.7,0,1.5-0.8,1.5h-7.7c-0.3,0-0.7-0.2-0.8-0.5L97.6,95.7 C97.1,95.1,97.6,94.2,98.4,94.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M126,86.4H54.8c-4.8,0-8.6-3.9-8.6-8.6V37.4c0-4.8,3.9-8.6,8.6-8.6H126c4.8,0,8.6,3.9,8.6,8.6v40.3 C134.6,82.5,130.7,86.4,126,86.4z"
}));

var SvgCameraSetupIcon = function SvgCameraSetupIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 150",
    style: {
      enableBackground: "new 0 0 150 150"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCameraSetupIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/camera-setup-icon.47949040.svg";
export { ForwardRef as ReactComponent };